import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './processcippage.cssmodule.scss';
import CreateIdeasHeader  from '../Shared/CreateIdeasHeader';
import ProcessCipForm from './ProcessCipForm';
import {Panel, FormControl, Button} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';
var NotificationSystem = require('react-notification-system');

class ProcessCipPage extends React.Component {

  constructor(props) {
    super(props);
    const {ideaId} = this.props;
    const { cipIdea } = this.props;
    const { cipFiles } = this.props;
    this.state = {ideaId : ideaId, cipIdea: cipIdea, cipFiles : cipFiles};
  }

  componentDidMount() {
     this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) { 
    const {ideaId} = nextProps;
    const { cipIdea } = nextProps;
    const { cipFiles } = nextProps;
    this.setState({ideaId : ideaId, cipIdea: cipIdea, cipFiles : cipFiles});
  }

  submitCipProgress(progress){
    const {ideaId} = this.props;
    const { actions } = this.props;
    const t = (message, data = {}) => {
        return intl.formatMessage({id : message}, data);
    };
    return actions.postCipProgressAction(ideaId, progress);
  }

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        return intl.formatMessage({id : message}, data);
    };
    const { cipIdea } = this.state;
    const { cipFiles } = this.state;
    const { authInfo } = this.props;
    
    return (
       <div className="container processcippage-component" styleName="processcippage-component" >
         <NotificationSystem ref="notificationSystem" />
        <CreateIdeasHeader ideaType = {this.props.ideaType}/>
        <div className="row" styleName="form-container">
          <div className="col-md-8">
            <Panel header={t('CI-Proposal') + ' #' + this.state.ideaId} className="brand-panel">
              <ProcessCipForm authInfo={authInfo}  cipIdea={cipIdea} cipFiles={cipFiles} onSubmit={this.submitCipProgress.bind(this)}/>
            </Panel>
          </div>
          <div className="col-md-4">
               <Panel header={t('GOOD TO KNOW')} className="brand-panel">
                      <p>{t('CIP_DESC')}</p>
               </Panel>
          </div>
        </div>
      </div>
    );
  }
}

ProcessCipPage.displayName = 'ProcessCIPPage';
ProcessCipPage.propTypes = {};
ProcessCipPage.defaultProps = {};

export default injectIntl(cssmodules(ProcessCipPage, styles));


// WEBPACK FOOTER //
// ./components/ProcessIdeas/ProcessCipPage.js